import { LoginRequest, LoggedAccount } from '../store/config/types/auth.types';
import axios from './axios';

async function login({
  email,
  password,
  device = 'admin',
  messagingToken = '',
  loginType = 'SHIPPER',
  userType = 'SHIPPER_USER',
}: LoginRequest) {
  const res = await axios.post('/auth/login', { email, password, device, messagingToken, loginType, userType });

  return res.data;
}

async function logout() {
  const res = await axios.get('/auth/logout');
  return res.data;
}

async function getAccount(shipperUserId: number) {
  const res = await axios.get(`/shipper_users/${shipperUserId}`);
  return res.data;
}

async function changePassword(shipperUserId: number | undefined, oldPassword: string, password: string) {
  return axios
    .patch(`/shipper_users/change-password/${shipperUserId ?? ''}`, { oldPassword, password })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      if (err.response) {
        throw err.response.data;
      }
    });
}

async function updateAccount(shipperUserId: number, shipperData: LoggedAccount) {
  const res = await axios.patch(`/shippers/${shipperUserId}`, shipperData);
  return res.data;
}

async function getDataProviderToken(currentToken?: string) {
  const res = await axios.get(`/data-provider/token?currentToken=${currentToken ?? ''}`);
  return res.data;
}

async function resetPassword() {
  window.location.href = process.env.REACT_APP_BACKEND_URL + '/auth/restore-password';
}

export const authService = {
  login,
  logout,
  getAccount,
  updateAccount,
  getDataProviderToken,
  changePassword,
  resetPassword,
};
